import { colors } from "constants/colors";
import styled, { css } from "styled-components";

export type StyledVideoPresenterProps = {
  maxWidth?: React.CSSProperties["maxWidth"];
  maxHeight?: React.CSSProperties["maxHeight"];
  aspectRatio?: string;
};

export const StyledVideoPresenter = styled.div<StyledVideoPresenterProps>`
  width: fit-content;
  position: relative;
  z-index: auto;

  display: flex;
  align-items: flex-end;
  background-color: ${colors.black};

  ${({ maxHeight }) =>
    maxHeight &&
    css`
      max-height: ${maxHeight};
    `};
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `};
  ${({ aspectRatio }) =>
    aspectRatio &&
    css`
      aspect-ratio: ${aspectRatio};
    `};
`;

export const StyledVideo = styled.video`
  object-fit: contain;
  max-height: 100%;
  max-width: 100%;
`;

export const StyledVideoTime = styled.div`
  background-color: ${colors.black};
  color: ${colors.white};
  width: fit-content;
  box-sizing: border-box;

  position: absolute;
  right: 0;
  bottom: 0px;

  padding: 5px;
`;
